var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000093",
    d: "M.667.667C.3.667 0 .967 0 1.333v9.334c0 .366.3.666.667.666.366 0 .666-.3.666-.666V1.333c0-.366-.3-.666-.666-.666ZM4.273 6l4.194-4.193a.664.664 0 1 0-.94-.94L2.86 5.533c-.26.26-.26.68 0 .94l4.667 4.667a.68.68 0 0 0 .946 0c.26-.26.26-.68 0-.94L4.28 6.007 4.273 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkBackIcon);
export default __webpack_public_path__ + "static/media/bulkBackIcon.b0f0ec802df4b4384ba60046c6edd646.svg";
export { ForwardRef as ReactComponent };